/**
 * Mirrors internal/portal's DefaultMaxUploadBytes (docs/api/portal-api.yaml
 * `/upload/partner` and `/upload/staff/{code}`: "Rejected with 413 if the
 * content exceeds MAX_UPLOAD_BYTES"). The backend is the real enforcement
 * point (checked from Content-Length up front, and again while streaming);
 * this constant only powers a client-side hint so a partner is warned
 * before starting a doomed multi-gigabyte upload, not a security control.
 */
export const MAX_UPLOAD_BYTES = 2146435072;

export const MAX_UPLOAD_BYTES_LABEL = "2047 MiB";
